import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Min

  <span style="color:#85c1dc;">**FI:**</span>
  Min

  <span style="color:#85c1dc;">**RU:**</span>
  Мин
*/
/* @__NO_SIDE_EFFECTS__ */
const m457 = msg(
  mf`Min`,
  mf`Min`,
  mf`Мин`,
)

export { m457 as 'w.module.filter_bar.min' }